import mimeDb from "mime-db";

export function getFileExtensionFromMimeType(mimeType, fileName) {
  const matchingTypes = Object.entries(mimeDb).filter(
    ([_, data]) => data.mime === mimeType
  );
  if (matchingTypes.length > 0) {
    return matchingTypes[0][1].extensions[0];
  }
  return fileName.split(".")[fileName.split(".").length - 1]; // If no matching extension found
}

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export async function objectUrlToBlob(objectUrl) {
  const response = await fetch(objectUrl); // Fetch the object URL
  const blob = await response.blob(); // Convert response to Blob
  return blob;
}